export enum reviewSectionsModal {
  PORTFOLIO_SUMMARY = 0,
  PROJECT_DETAIL = 3 || 4 || 5 || 6,
  CURRENT_REVISION_AGREEMENTS = 7 || 8 || 9 || 10 || 11 || 12,
}
